export default async () => {
  return await Promise.resolve({
    loading: 'Loading...',
    prev: 'Previous',
    next: 'Next',
    hours: 'hour | hour | hours',
    minutes: 'minute | minute | minutes',
    seconds: 'second | second | seconds',
    the: '',
    and: 'and',
    copyright: '{year} © Asphalte. All rights reserved.',
    b_corp_certified: 'Certified B Corp',
    color: 'Color:',
    hovered_color: 'Hovering color:',
    preco_of_the_week: 'This week only!',
    next_thuesday: 'See you next Tuesday at 10am (CET).',
    lauch_day: 'See you next {day} at 10am (CET).',
    seo: {
      defaultTitle: 'Asphalte - Good clothes. Period.',
      defaultDesc:
        "We're on a mission to kit out as many people as possible in quality clothes.",
    },
    context: {
      h: 'Homme',
      f: 'Femme',
    },
    action: {
      see: 'See product',
      add: 'Add',
      added: 'Added',
      edit: 'Edit',
      delete: 'Delete',
      buy: 'Buy',
      copy: 'Copy',
      share: 'Share',
      preorder: 'Preorder',
      'add-to-cart': 'Add to cart',
      subscribe: 'Create notification',
      unsubscribe: 'Turn off the notification',
      checkout: 'Checkout securely',
      reduce: 'Show less',
      open: 'Open',
      open_filters: 'Access filters',
      filter: 'Filter products',
      'continue-shopping': 'Continue shopping',
      show_ehsop: 'Show me the preorders',
      close: 'Close',
      cancel: 'Cancel',
      cancel_product: 'Cancel product',
      seePassword: 'See password',
      hidePassword: 'Hide password',
      newsletterSubscribe: 'Stay in the loop',
      readMore: 'Read more',
      showAllPictures: 'Show all photos',
      subscribe_to_list: 'I sign up',
      follow_order: 'Track my order',
      logout: 'Log out',
      return: 'Return an article',
      add_address: 'Add an address',
      edit_address: 'Edit address',
      set_as_default: 'Primary address',
      save: 'Save',
      update_password: 'Update password',
      show_care_guide: 'Show care guide',
      prev: 'Previous',
      next: 'Next',
    },
    link: {
      menu: 'Menu',
      infos: 'Alerts',
      cart: 'Cart',
      'sign-in': 'Sign in',
      news: 'News',
      account: 'My account',
    },
    alert: {
      title: 'My notifications',
      desc: `
      <p>Looking for the news on those Asphalte products that you’ve been eagerly awaiting? This is the spot - here’s where all the notification updates on items you’ve signed up for live. Handy, right?</p>
      <p>If you don't see anything here at all, it's probably because nothing’s caught your eye... Don’t worry. It happens, we don't take it personally.</p>
      <p>Of course, if you think something’s missing, you can always take a look-see at all the upcoming launches.</p>
      `,
      action: 'What’s on the horizon?',
      none: 'You have no notification for the moment.',
      tooltip: {
        create: 'Set notification',
        remove: 'Cancel notification',
        love: 'Set notification',
        unlove: 'Cancel notification',
      },
    },
    article: {
      publicated_at: 'Published on {date}.',
      next: 'Next article',
    },
    stock: {
      title: 'Stock sale',
      punchline: 'Quick delivery.',
      teasing_action: 'Show me',

      alert: {
        1: "It's first come, first served.",
        2: 'Sign up to get an hour head start on the stock sale.',
        highlight_title: 'Stock sale begin at {date}',
        receive_alert:
          'Sign up here to be notified when the the stock sale will be available :',
        activated:
          'We will notify you when the stock sale open from this email address <strong>{email}</strong>.',
        deactivated:
          'You will no longer be notified when the stock sale is open',
      },
    },
    card: {
      product: {
        agenda: {
          status: 'Up soon',
          alert: {
            1: 'It’s first come, first served.',
            2: 'Sign up to get an hour head start on the preorder.',
          },
        },
        precommande: {
          status: 'Preorder launch',
        },
        stock: {
          status: 'Back in stock',
        },
        'number-of-colors': '{number} colours available',
        'number-of-colors-soon':
          '1 colour available | {number} colours available',
        'number-of-colors-small': '{number} colors',
        'nb-preco':
          'Already <strong>{number}</strong> preorder | Already <strong>{number}</strong> preorder | Already <strong>{number}</strong> preorders',
      },
    },
    cart: {
      title: 'My cart',
      empty: 'Your cart is empty.',
      'sub-total': 'Subtotal',
      'shipping-calculated-later': 'Shipping & taxes calculated at checkout',
      'terms-agree': 'I agree with the',
      'terms-agree-error': 'You must agree to the terms',
      delivery: 'Free delivery when you place an order/preorder over {price}€',
      free_delivery_left:
        'Only <strong class="text-color-secondary">{price}€</strong> to go to get free delivery',
      delivery_free: 'We hope you enjoyed it!',
      delivery_free_sub: 'Delivery’s on us.',
      cgv: 'terms and conditions',
      upsell: {
        title: {
          default: 'You may also like',
          empty: 'Take a look at the Asphalte favourites.',
          link: 'Additional item',
          'Les éternels': 'You may also like',
          Cluster: 'Looks good with',
        },
        default: 'Also in preorder',
        link: 'For your suit',
        'Les éternels': 'Our essentials',
        Cluster: 'Delivered together',
        info: 'Now up for preorder | Available in {number} colours',
        action: 'Show me',
        h: {
          default: 'For him / Also in preorder',
          'Les éternels': 'For him / Our essentials',
        },
        f: {
          default: 'For her / Also in preorder',
          'Les éternels': 'For her / Our essentials',
        },
      },
      payments: 'Payment methods',
    },
    cookie: {
      text: 'By continuing to browse the site, you agree to our use of cookies.',
      link: 'Find out more',
    },
    label: {
      color: 'Color:',
      size: 'Size:',
      jacket: 'Jacket size:',
      pant: 'Pants size:',
      amount: 'Amount:',
      quantity: 'Quantity:',
    },
    locale: {
      'de-DE': 'Deutsch',
      'en-US': 'English',
      'fr-FR': 'Français',
      small: {
        'de-DE': 'DE',
        'en-US': 'EN',
        'fr-FR': 'FR',
      },
    },
    countdown: {
      days: 'day | days',
      hours: 'hour | hours',
      minutes: 'minute | minutes',
      seconds: 'second | seconds',
      abbr: {
        days: 'D-{days}',
        hours: 'H-{hours}',
      },
    },
    faq: {
      title: 'FAQ',
      line1: {
        title: 'How can I spend my Asphalte balance?',
        content:
          'Just copy your balance code and apply it at check out on our site when placing an order. You can spend it on any item from preorder or stock, just not to cover shipping costs.',
      },
      line2: {
        title: 'What clothing can I buy with this code?',
        content:
          'The code works on the site for all items for sale, both preorder and from stock.',
      },
      line3: {
        title:
          'What happens if my balance is greater than the cost of my order?',
        content:
          'No worries, we just adjust your balance accordingly. If you have a balance of €100 on your Asphalte account and you buy an item of clothing for €79, your new available balance will be €21.',
      },
      line4: {
        title: 'Can the same balance code be used several times?',
        content:
          'Yes, you only have one balance code which you can use every time you order as long as there’s credit on it.',
      },
      line5: {
        title: 'Can I give my balance code to someone else?',
        content:
          "No, your balance code is directly linked to your customer account and can only be used by you. So if you want someone else to use your balance, you'll have to order for them or give them access to your customer account.",
      },
    },
    header: {
      menu: {
        eshop: 'E-shop',
      },
    },
    footer: {
      cgv: 'Terms & Datas',
      cookie: 'Cookies',
      newsletter: {
        man: 'Male',
        woman: 'Female',
        subscribe: 'Great, got it!',
        error: 'Oh no... Something bad happened.',
      },
      payments: {
        info: 'An indication of all payment methods available for your purchase. This choice will however depend on your end-delivery address.',
      },
    },
    create_alert: {
      email: { placeholder: 'Pop your email right here' },
      subscribe: 'Sign me up',
    },
    product: {
      in_preco: 'By preorder',
      in_stock: 'From stock',
      'available-from': 'Available from {weekday}, {month-day}',
      'receive-alert-preorder':
        'Sign up here to be notified when the item is available for preorder:',
      'receive-alert-stock':
        'Sign up here to be notified when the item is available in stock:',
      'color-not-available': 'You out-knitted us',
      'size-not-available': 'This size is now out of stock.',
      'soldout-saisonnier': `Sorry, but we seemed to have run out of thread for this colour. You can be the first to know when this item is available for preorders again.`,
      'back-one-day': 'Back one day',
      price_range: 'From {min} € to {max} €',
      available_sizes: 'Available size:',
      tag: {
        soon_preco: 'Preorder starts in',
        last_before_end: 'Preorders closing in',
        last_chance: 'Last chance',
        new_color: 'New colour',
        leaving_soon: 'Leaving soon',
      },
      soldout:
        'Sorry, but we seemed to have run out of thread for this colour. You can be the first to know when this item is available for preorders again.',
      soldout_stock:
        'The stock for this color is sold out. Please sign up below, and you will be the first to be notified when this color is back in stock.',
      almost_sold_out:
        '<strong>Last item available</strong> | Only <strong>{number} pieces left</strong>',
      sold: 'Already <strong>{sold}</strong> pré-order | Already <strong>{sold}</strong> preorders',
      alert: {
        activated:
          'We will notify you when {produit} are available again from his email address <strong>{email}</strong>.',
        deactivated:
          'You will no longer be notified when the {produit} is up for preorder',
        'unsubscribe-loading': 'Unsubscribed in process',
        love: '{produit} is/are now on your hunting list. You can count on us to send you an email as soon as they are available.',
        unlove:
          "{produit} has/have been removed from your favourites. You've fallen in love, let's forget about it, and life goes on.",
        error:
          'An error occurred as you were setting up your notification. If the problem continues, please get in touch with customer service.',
        highlight_title: '{name}: {date}',
        modal: {
          title: 'Notification saved!',
          NOT_FOUND: {
            subtitle: 'Create an account to manage your alerts.',
            explanations:
              'It looks like you haven’t set up your account yet. Once that’s done, you won’t need to enter your email every time you sign up for something and you’ll be able to manage all your product notifications in 1 place.',
            where: 'It’s a few minutes well spent if you like to save time.',
            action: 'Set me up',
          },
          ENABLED: {
            subtitle: 'Log in to manage your alerts.',
            explanations:
              'You’ll be the first to know the moment the item is back up for preorder or in stock!',
            where:
              'If you change your mind, no worries. Head to your customer account to change your notification settings.',
            action: 'Log in',
          },
          DISABLED: {
            subtitle: 'Activate your account to manage your alerts.',
            explanations:
              'It looks like you haven’t activated your account yet. Once that’s done, you won’t need to enter your email every time you sign up for something and you’ll be able to manage all your product notifications in 1 place.',
            where: 'It’s a few minutes well spent if you like to save time.',
            action: 'Activate my account',
          },
          unsubscribe: {
            title: 'Notification unsaved!',
            NOT_FOUND: {
              explanations:
                'It looks like you haven’t set up your account yet. Once that’s done, you won’t need to enter your email every time you sign up for something and you’ll be able to manage all your product notifications in 1 place.',
              where: 'It’s a few minutes well spent if you like to save time.',
            },
            ENABLED: {
              explanations:
                'All done now. You will no longer be the first to know...',
              where:
                'If you change your mind, no worries. Head to our Coming Soon page to change your notifications.',
            },
            DISABLED: {
              explanations:
                'It looks like you haven’t activated your account yet. Once that’s done, you won’t need to enter your email every time you sign up for something and you’ll be able to manage all your product notifications in 1 place.',
              where: 'It’s a few minutes well spent if you like to save time.',
            },
          },
        },
      },
      nav: {
        product: 'Item',
        videoBlock: 'Video',
        issueBlock: 'What we fixed',
        user_generated_content: 'Get inspired',
        simpleContentBlock: 'Description',
        morphoBlock: 'Sizing',
        tracabiliteBlock: 'Traceability',
        impactBlock: 'Environmental impact',
        avisClientBlock: 'Customer reviews',
        assuranceBlock: 'Our guarantees',
        other: 'Others',
        action: {
          precommande: 'Preorder',
          stock: 'Buy',
          agenda: 'Create notification',
        },
      },
      material: {
        title: 'Material:',
        label: '{label}:',
        popup:
          '<p class="d-flex align-center text-base-mobile mb-0-6">{icon} <strong class="ml-0-4">{label} {name}</strong></p>',
      },
      filters: {
        type: {
          Accessoires: 'Accessories',
          Chaussures: 'Shoes',
          Chemises: 'Shirts',
          Costumes: 'Suits',
          'Manteaux et Vestes': 'Coats and Jackets',
          'Pantalons et Shorts': 'Pants and Shorts',
          'Pulls et Sweats': 'Sweaters and Sweatshirts',
          'Sous-vêtements et Maillots de bain': 'Underwear and Swimwear',
          'T-shirts et Polos': 'T-shirts and Polos',
        },
      },
      color: {
        leaving_soon: {
          title: 'Leaving soon.',
          desc: '{left} to preorder {product} in {colour}. After this deadline, this colour will no longer be available for preorder.',
          days_left: 'Last day | Only 1 day left | {count} days left',
          some_days: 'Only a few days left',
          ended: 'Preorder for the colour has ended.',
        },
        new: {
          title: 'Brand new colour',
          desc: 'Just released.',
        },
      },
    },
    purchase: {
      price: {
        preco: 'Preorder',
        stock: 'In stock',
      },
      timer: {
        before: 'Order in the next',
        over: 'Preorder closed',
        only: 'Only',
        left: 'left',
      },
      estimatedDelivery: 'Estimated delivery :',
      delivery: 'Delivery :',
      batchEnd:
        'to receive delivery between<br />the {first} and the {last} of {month}',
      precoEnd: 'before the end of the preorder',
      stockEnd: 'before the end of sale',
      precoEndTooltip:
        'First come, first served. You know the drill. If you preorder right now, you’ll receive your item between the {current_first} and the {current_last} {current_month}. If you leave it ‘till next week, it will be delivered between the {next_first} and the {next_last} {next_month}. Pretty straightforward, right?',
      already: 'Already',
      preco: 'preorders',
      nextPrecoDelivery: 'to receive delivery between',
      nbPreco: 'preordered pieces',
      inStock: 'pieces in stock',
      'size-guide': 'Size guide',
      exchange: 'Shipping & Returns',
      fewDays: 'in a few days.',
      noDays: 'No date at the moment.',
      contactCare: 'For more information, please contact our customer service',
      beforeChristmas: 'Before Christmas',
      stock_preco_why: 'How does it work??',
      between: 'Between the {first} and the {last} of {month}',
      fromTo: '{first} and {last} {month}',
      label: {
        jacket: 'Jacket:',
        pant: 'Pants:',
      },
      no: {
        jacket: 'No jacket',
        pant: 'No pants',
      },
      errors: {
        size: {
          empty: 'Please select a size',
        },
        addToCart: {
          fail: 'Uhoh, looks like there’s a technical issue. Please come back and try again later. Alternatively, <a href="https://help.asphalte.com/article/yni5jp9af8-contact" target="_blank">you can get in touch with our customer service team</a> with any pressing requests.',
        },
      },
    },
    orders: {
      error: {
        loading:
          ' Whoops, that’s not gone to plan. Try reloading the page, if that doesn’t fix the bug, please give our customer service whizzes a shout. They’ll jump on it.?',
      },
      title: 'My orders',
      almost_there: 'With you shortly!',
      filters: {
        label: 'My last orders:',
        in_progress: 'pending',
        returns: 'Exchanged',
        year: '{year}',
      },
      no_order: 'No orders made as yet',
    },
    order: {
      number: 'Order n°',
      number_param: 'Order n°{number}',
      number_full: 'Order number :',
      created_at: 'made one',
      channel: {
        label: 'Order placed:',
        online: 'Online',
        retail: 'In store',
      },
      delivery_at: 'Delivery to',
      go_to: 'Show order details',
      detail: 'Order details',
      print: 'Print the invoice',
      shipping: 'Method of delivery',
      shipping_address: 'Delivery address',
      billing_address: 'Invoice address',
      update_address: {
        title: 'Update Delivery Address',
        edit: 'Update My Address',
        label: 'Information:',
        info: 'We will contact you by email a few days before delivery in case you need to change at the last moment.',
        pickup_point_update:
          'Do you prefer to pick up your order at a pickup point?',
        change_to_pickup_point: 'I choose delivery to a pickup point',
        update_pickup_point: 'Update Pickup Point',
        choice: 'Delivery Mode Choice',
        choose_home_delivery: 'I want home delivery',
        lock_country_reason:
          'You cannot change the delivery country associated with the initial order. If this is a specific request, please contact our customer service.',
        delivery: {
          domicile: 'Home Delivery',
          relais: 'Pickup Point Delivery',
          new_address: 'Add a New Address',
          save_for_later: 'Add this address to my address list',
          hide_all_addresses: 'Hide All Saved Addresses',
          show_all_addresses: 'Show All Saved Addresses',
          save: 'Update Delivery Address',
          error_no_address: 'Please select a delivery address',
        },
        pickup_point: {
          search_label:
            'Around which area would you like to search for a pickup point?',
          search: 'Show pickup points around this address',
        },
        error: {
          default:
            "An error occurred while updating the delivery address. If the problem persists, please don't hesitate to contact our customer service.",
          cannot_change_shipping_country:
            'You cannot change the shipping country associated with the original order. If this is a special request, please contact our customer service.',
        },
      },
      home_delivery: 'Delivery to your door',
      relay_point_delivery: 'Pickup point delivery',
      see_map: 'See on the map',
      email: 'Email address',
      paymentMode: 'Payment method',
      phone: 'Telephone',
      follow: 'Track my parcel',
      delivered_by: 'Track my {trackingCompany} delivery',
      fullfilment_number: 'Parcel number :',
      inside_box: "What's inside the box",
      canceledAt: 'Order canclled on {date}',
      refunded: 'Amount refunded',
      cancel_reason: {
        CUSTOMER: 'Order cancelled by customer request',
        DECLINED: 'Order cancelled because of payment declined',
        FRAUD: 'Order cancelled because of possible fraud',
        INVENTORY: 'Order cancelled because of lack of inventory',
      },
      delivery: 'Expected delivery',
      initial_delivery: 'Initial expected delivery: ',
      new_delivery: 'New expected delivery: ',
      careGuide: 'Care guide',
      retoucheurs: 'Make alterations',
      line: {
        'in-some-days': 'Delivery expected : in a few days',
        deleted: 'The item was removed from the order',
      },
      returns: {
        title: 'Returns',
        'how-to': 'Everything you need to know about returns',
        explains:
          "If an item isn't up to scratch, or the right size, you can return it by clicking the button below:",
      },
      recap: 'Order summary',
      subtotal: 'Subtotal :',
      discount: {
        items: 'Discount on items ',
        shipping: 'Discount on delivery costs',
      },
      'shipping-price': 'Delivery costs',
      total: 'Total paid',
      exchange: 'Exchanged following return',
      inside: 'In my order',
      items: '{number} item(s) | {number} item(s)',
      shippingStatus: {
        DELIVERED: 'Delivered',
        PACKED: 'Ready to ship',
        SHIPPED: 'Shipped',
        RAW: 'In progress',
      },
      status: {
        label: 'Status',
        label_pt: 'Status :',
        RAW: 'In progress',
        CANCELED: 'Cancelled',
        CANCELLED: 'Cancelled',
        AUTHORIZED: 'Authorised',
        PAID: 'Paid',
        PARTIALLY_PAID: 'Partially paid',
        PARTIALLY_REFUNDED: 'Partially refunded',
        PARTLY_DELIVERED: 'Partially delivered',
        PENDING: 'Awaiting payment',
        REFUNDED: 'Refunded',
        DELIVERED: 'Delivered',
        EXCHANGE: 'Exchanged',
        IN_TRANSIT: 'Out for delivery',
        VOIDED: '',
      },
      line_item: {
        CANCELED: 'Cancelled',
      },
      timeline: {
        created: 'Order received',
        packed: 'Parcel shipped, off we go',
        in_transit: 'Parcel on its way, any minute now',
        delivered: 'Finally in your hand',
      },
      pickup_point: {
        opening_hours: 'Opening Hours',
        opening_days: 'Open on <strong>{days}</strong>',
        all_days: 'Open <strong>every day</strong>',
        closed: 'Closed',
        open: {
          during_lunch: 'During Lunch',
          after_7: 'After 7 PM',
        },
        days: {
          0: 'Monday',
          1: 'Tuesday',
          2: 'Wednesday',
          3: 'Thursday',
          4: 'Friday',
          5: 'Saturday',
          6: 'Sunday',
        },
        show_hours: 'View Opening Hours',
        hide_hours: 'Hide Opening Hours',
      },
      error: {
        shipping_loading:
          'There was an error loading your delivery address. If the problem persists after reloading your page, please contact our customer service.',
      },
    },
    sponsorship: {
      title: 'Our referral program',
      intro: `
        <p>Let’s get down to brass tacks on this one.</p>
        <p><strong>For the uninitiated, this is how the program works:</strong></p>
        <p>
          When you refer a friend to Asphalte, who then uses your unique code at checkout, 
          you get <strong>{parrainageprice}€ added to your kitty</strong> and they get {parrainagefilleulprice}€ off their <strong>first order</strong>. 
          Everyone’s a winner - as long as they remember to put that referral code in! Stamp it on their head or something…
        </p>
        <p>And — before you ask — here’s your magic code, ready to share with those who really deserve it:</p>
        `,
      code: 'My referral code:',
      messageToShare:
        'Not the letter-writing sort? Let’s give you a hand when it comes to explaining what we do to those that don’t know us yet:',
      message: `Never heard of Asphalte? They’re a French clothing company that make traceable, top-quality clobber, fairly made in Europe using a preorder model that cuts waste and offers a better way of making and buying clothes. Sounds pretty good, right? Want {parrainageprice}€ off your first order? Course you do. All you need to do is use this referral code at checkout: {code}.
        Head over to the site to see what’s up for grabs: <a href="{link}"><u>{link}</u></a>`,
      after_message: 'Easy as that, no AI required.',

      cagnotte: {
        title: 'Your Account Balance',
        explain: `<p>Let’s not forget about you in all this.</p>
          <p>You can spend the balance of your Asphalte kitty anytime. All you need to do is copy your code into the “Promotional Code” section at checkout.</p>
          <p>Here’s where you can keep an eye on how much credit you’ve clocked up.</p>`,
        'you-have': 'Your balance is',
        code: 'My kitty code (to use at checkout):',
      },

      cheat: {
        title: 'A heads-up for the wise guys:',
        text: 'The referral program only works if it’s not abused. So, let’s play by the rules. Don’t go setting up fake accounts under false names via off-shore accounts and so on… You’ll only get busted and lose all your credit (see our T&Cs). If you’re that keen, you’d be better off spending the time actually getting your referral code out to people who’re interested, helping support a company you like while you’re at it. A better bet, right?',
      },
      faq: {
        line1: {
          title: 'Who can refer friends?',
          content:
            "Only existing customers who've already placed an order and created an account.",
        },
        line2: {
          title: 'Who can I send my unique referral code to?',
          content: 'Anyone who has not yet ordered on our site.',
        },
        line3: {
          title: 'Are all delivery charges free?',
          content:
            'Anyone you refer and is ordering from Asphalte for the first time will benefit from free delivery as long as the delivery charges in their region are no greater than €15.',
        },
        line4: {
          title: 'How can I refer a friend?',
          content:
            "It's easy. Just share your unique referral code for your friends to apply at checkout on our site. Please note that a minimum purchase of 50 euros is required for the code to be valid.",
        },
        line5: {
          title: 'Can I refer several friends?',
          content:
            'Yes, for sure. So, if the question is: can my friends pay for Asphalte clothes for me? The answer is yes!',
        },
        line6: {
          title: 'Is there a limit to the number of friends I can refer?',
          content:
            "Yes, we've capped the number of referrals per person to 25.",
        },
        line7: {
          title: 'When will my balance be credited?',
          content:
            "As soon as your referral's order is confirmed we'll send you an email to let you know that we’ve added {parrainageprice}€ to your Asphalte balance which you can use immediately.",
        },
      },
      requirements: 'You must place an order to activate your referral code',
    },
    people: {
      verified: 'Verified buyeur',
    },
    testimonial: {
      action: {
        show: 'See testimonials',
        hide: 'Hide testimonials',
      },
      see: 'See the {number} testimonials',
      based_on_number: 'Based on {number} reviews',
      size: 'Size:',
      color: 'Color:',
      number: '{number} review | {number} reviews',
      'based-on': 'Based on {number} reviews',
      'no-comment': 'No comment',
      empty: 'No testimonial match with these filters',
      loading: 'Loading testimonials',
      filter: {
        by: 'Filter by:',
        color: 'Color',
        size: 'Size',
        note: 'Note',
      },
    },
    impact: {
      unit: {
        Carbone: 'kg',
        Eau: 'L',
        Energie: 'MJ',
        Phosphate: 'g',
      },
      conso: {
        Carbone: 'of CO2 emitted',
        Eau: 'water consumption',
        Energie: 'energy depletion',
        Phosphate: 'of phosphor released in the water',
      },
      detail: {
        Carbone: 'sources: European Environment Agency, november 2020.',
        Eau: 'Measurements based on the national average, Véolia',
        Energie: 'Sources Engie, january 2020',
        Phosphate: 'Sources AgriBalyse, https://agribalyse.ademe.fr/',
      },
    },
    input: {
      empty: 'Required input',
      optional: 'Optional',
      gender: {
        homme: 'Mr',
        femme: 'Mrs',
        undefined: 'Non-binary',
      },
      email: {
        label: 'Email',
        placeholder: 'Your email here',
        wrong: 'You must fill in an email',
      },
      error: {
        UNIDENTIFIED_CUSTOMER: 'Invalid password',
        BAD_DOMAIN: '',
        BLANK: '',
        CONTAINS_HTML_TAGS: '',
        CONTAINS_URL: '',
        CUSTOMER_DISABLED: '',
        INVALID: '',
        INVALID_MULTIPASS_REQUEST: '',
        NOT_FOUND: '',
        PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE: '',
        TAKEN: '',
        TOKEN_INVALID: '',
        TOO_LONG: '',
        TOO_SHORT: '',
        ALREADY_ENABLED: 'Your account is already activated',
        PHONE: 'Invalid phone number',
        passwordLength: 'The password must contain at least 6 caracters',
        password_match: 'The passwords do not match.',
        invalid_password: 'The password is incorrect.',
        sexe: 'Select a choice',
        firstName: 'Invalid firstname',
        lastName: 'Invalid lastname',
      },
    },
    account: {
      hello: 'Hi there',
      welcome:
        'Welcome to your <span class="text-color-secondary">Asphalte account page</span>',
      enjoy: {
        default:
          'Roses are red, violets are blue, at Asphalte we make shopping sustainably easier for you.',
        birthday: 'Happy birthday! See, we do care.',
        morning: 'Morning',
        day: 'How’s the day going so far?',
        evening: 'Evening',
        new_year: 'New Year, new you. The same Asphalte promise.',
        first_order_birthday: 'It’s been a while, great to see you back again.',
      },
      label: 'My Account',
      labels: {
        email: 'Email',
        password: 'Password',
        birthday: 'Birthday',
        gender: 'Gender',
        firstname: 'Firstname',
        lastname: 'Lastname',
        phone: 'Phone',
        current_password: 'Current password',
        new_password: 'New password',
        new_password_confirmation: 'Confirm new password',
      },
      nav: {
        home: 'My account',
        orders: 'My order history',
        profile: 'My account',
        address: 'My addresses',
        parrainage: 'My Asphalte kitty',
        alerts: 'Keeping me in the',
        logout: 'Log out',
      },
      menu: {
        orders: {
          preTitle: 'My',
          title: 'Order history',
          description:
            'Here’re all the orders you’ve ever placed - along with invoices and all the after sales service paperwork.',
        },
        profile: {
          preTitle: 'My',
          title: 'Account',
          description:
            'Need to change up your email address, password, personal details? Step right this way.',
        },
        address: {
          preTitle: 'My',
          title: 'Addresses',
          description:
            'Here’s the spot for confirming delivery addresses and preferences - you don’t want your Asphalte goods falling into the wrong hands now, do you?',
        },
        alerts: {
          preTitle: 'Keeping',
          title: 'me in the know',
          description:
            'Want to speak to us daily? We’re flattered. Want to hear from us a little less? We understand. Either way - this is where you can manage your Asphalte notifications and choose the newsfeeds you want to follow.',
        },
        parrainage: {
          preTitle: 'My',
          title: 'Asphalte kitty',
          description: 'Referral program and code.',
        },

        care_guides: {
          preTitle: 'Our',
          title: 'Care guides',
          description: 'All our tips for looking after your clothes and shoes.',
        },
      },
      address: {
        default: 'My primary address',
        is_default: 'Primary',
        list: 'All my addresses',
        create: 'New address',
        edit: 'Edit an address',
        firstName: 'Name',
        lastName: 'Surname',
        companyName: 'Company',
        address1: 'Address',
        address2: 'Additional address details',
        city: 'Town',
        postalCode: 'Postcode',
        country: 'Country',
        province: 'Province',
        state: 'State',
        select_province: 'Select a province',
        select_state: 'Select a state',
        phone: 'Phone',
        phone_explain:
          'So that our delivery partner can contact you in case of an issue with your delivery.',
        error:
          'Whoops, we’ve encountered error occured here somewhere. Contact our customer service if it doesn’t magically solve itself. ',
        error_taken: 'This address has already been saved',
        no_address: 'No addresses saved so far.',
      },
      profile: {
        informations: 'My Information',
        password: 'My Password',
        no_mail:
          "You can't currently change your email, as the functionality is not yet operational on our end. If you need to update your email, feel free to contact customer service.",
      },
      title: 'Login',
      p1: "To sign in to your account or create one if you haven't yet, please type in your email address here.",
      placeholder: {
        email: 'example@email.com',
      },
      error: {
        email: 'Invalid email',
      },
      nextButton: 'Login',
      activationLinkSent:
        'We recently sent you an email to inform you that we have migrated to a new website platform. For security purposes we must ask you to click on the “reactivate my account” button in the email to be able to access your customer account and enjoy the new features.',
      /* 'An email has been sent to you, click on « Activate my account » to complete your registration and track your order.', */
      wait: "If you haven't received an email from us within the next 10 minutes, give it another go.",
    },
    password: {
      security: {
        advice:
          'We recommend you choose a secure password that meets the following criteria:',
        length: 'Contains a minimum of 8 characters',
        uppercase: 'Contains at least one uppercase letter',
        lowercase: 'Contains at least one lowercase letter',
        number: 'Contains at least one digit',
        special: 'Contains at least one special character',
        label: 'Security:',
        weak: 'Weak',
        medium: 'Medium',
        strong: 'Strong',
      },
    },
    register: {
      title: 'Register',
      p: 'A little bird told us that you don’t have an Asphalte account. No worries, we’ll get you up and running in no time. Just answer the following questions:',
      placeholder: {
        firstName: 'Joe',
        lastName: 'Random',
      },
      error: {
        unexpectedError:
          'An error has occurred, please contact customer service',
      },
      password: 'Password',
      changeEmail: 'Change my email',
      nextButton: 'Next',
      sendButton: 'Register',
      sexe: 'Gender',
      men: 'Male',
      women: 'Female',
      firstName: 'First name',
      lastName: 'Second name',
      date: 'Date of birth',
      news: 'Sign up',
      newsText:
        'I’d like to be kept informed of what’s going on (questionnaires, preorder launches…) but don’t over do it.',
    },
    activate: {
      title: 'Activate your account',
      p: 'You placed an order on our site at some point but haven’t yet activated your account. We’ve got a few questions to get you up and running, it ‘ll only take a few minutes.',
      sendButton: 'Activate your account',
    },
    login: {
      title: 'Login',
      p: "It's good to see you around again. We'll let you enter your password and we'll meet right after.",
      placeholder: {
        password: 'at least 6 characters',
      },
      password: 'Password',
      forgotPasswordLink: 'Forgot your password ?',
      codeSent: 'Email sent',
      forgotPasswordLinkSent:
        'A password reset email has been sent to your contact address.',
      sendButton: 'Login',
      rememberMe: 'Remember me',
    },
    reset_password: {
      title: 'Reset My Password',
      desc: 'No worries! Enter a new password for your account',
    },
    request: {
      failed: 'Request failed',
      'no-result': 'No result',
    },
    blog: {
      news: {
        noPost: 'No article at this moment.',
      },
      'guides-dentretien': {
        noPost: 'No care guide at this moment.',
      },
    },
    error: {
      happened:
        'Houston, we have a problem. The mission has failed for unknown reasons. If the issue persists after refreshing the page, feel free to contact our customer service. Copy?',
      default: {
        title: 'there seems to be a mistake here.',
        text: "this page isn't available.",
        backToHome: 'Back to the home page',
      },
      reset_password: {
        INVALID:
          'Houston, we have a problem. The link is no longer valid... Please restart the procedure from the beginning. If the problem persists after multiple attempts, feel free to contact our customer service. Copy?',
        PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE:
          'Houston, we have a problem. The password cannot start or end with a space.',
        TOO_LONG: 'Houston, we have a problem. The password is too long.',
        TOO_SHORT: 'Houston, we have a problem. The password is too short.',
      },
      404: {
        title: '404 - Page not found.',
      },
    },
    search: {
      type: {
        agenda: 'Agenda :',
        eshop: 'Eshop :',
        stock: 'Stock :',
      },

      label: {
        article: 'Looking for an article?',
        care_guide: 'Are you looking for a care guide?',
      },

      no_result: 'No results found',
      results: '{number} result | {number} result | {number} results',
      'number-of':
        '{number} product available | {number} product available | {number} products available',
      display: {
        cols: '1 row | {number} rows',
        pageSize: {
          title: 'Nombre de produits par page',
        },
        listDisplay: {
          title: 'Affichage de la liste',
          list: 'Liste',
          grid: 'Grille',
        },
      },
      filter: {
        loading: 'Loading',
        reset: 'Reset filters',
        all_reset: 'Reset all filters',
        title: 'Filters',
        wait_for_category: 'Select a category to filter by size',
        category: {
          title: 'Category',
          all: 'All',
        },
        size: {
          title: 'Size',
          all: 'All',
        },
        price: {
          title: 'Price',
          all: 'All',
        },
      },
      categories: {
        't-shirt': 'T-shirts',
        pulls: 'Jumpers',
        'pants-shorts': 'Trousers & Shorts',
        chemises: 'Shirts',
        'manteaux-vestes': 'Coats & Jackets',
        chaussures: 'Shoes',
        costumes: 'Suits',
        accessoires: 'Accessories',
        maillots: 'Underwears & Swimsuits',
      },
    },
    teasing: {
      title: 'IS THIS PICTURE BLURRY?',
      dates: '',
      subscribe:
        'It says you have to <strong>sign up</strong> if you want to see it all now.',
      slice: {
        title: 'IS THIS PICTURE BLURRY?',
        dates: '',
        subscribe:
          'It says you have to <strong>sign up</strong> if you want to see it all now.',
      },
      story: {
        title_1: 'IS THIS PICTURE BLURRY?',
        title_2: 'Good try. Still fuzzy…',
        title_3: 'Yep. It’s not changing.',
        title_4: 'Non. Nein. No dice!',
        title_5: 'Someone’s keen.',
        title_6: 'You haven’t left yet?',
        title_7: 'Do you really have nothing else on?',
        title_8: 'OK. We give up.',
        title_inf: 'OK. We give up.',
      },
    },
    'co-creation': {
      title: 'Over to you',
    },
    notification: {
      text: 'How about we keep you posted on our next releases?',
      positive: 'Keep me in the loop',
      negative: 'Nah, I’m good thanks',
    },
    questionnaire: {
      new: 'New!',
      available: 'Available',
      type: {
        'plan-de-collection': 'Collection questionnaire',
        development: 'Development questionnaire',
        'achat-matiere': 'Colour questionnaire',
        satisfaction: 'Satisfaction questionnaire',
        brand: 'Brand questionnaire',
        'autres-sujets': 'Other questionnaires',
      },
    },
    collection: {
      unlock: {
        error: 'Good effort, but try again. The password doesn’t match.',
        done: {
          title: "You're in!",
          text: 'Get early access to the Asphalte end of summer stock sale. You have until 10 am before it opens to the public.',
        },
        input_password: {
          label: 'Enter your password to access the stock sale',
        },
        action: 'Gooooo',
      },
    },
    banner: {
      app: {
        title: 'Download the Asphalte app.',
        text: 'And come with us into the year 2000.',
      },
    },
  })
}
